<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view v-if="isRouterAlive" :key="(new Date()).valueOf()"/>
  </div>
</template>

<style>
@import "./assets/css/base.css?v=1";
@import "./assets/css/m.css";

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*min-height:100vh;*/
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>

<script>
import {Check_Expire_Date} from '@/api/index';

export default {
  name: 'App',
  provide() {
    return {
      reload: this.reload
    }
  },
  data() {
    return {
      isRouterAlive: true
    }
  },
  mounted() {
    setInterval(this.checkExpireDate, 5 * 60 * 1000)
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    checkExpireDate() {
      const user = JSON.parse(localStorage.getItem('User') || {})
      if (user && user.accessToken) {
        Check_Expire_Date({
          expireDate: user.expireDate
        }).then(res => {
          console.log(res)
        })
      }
    }
  },
  components: {}
}
</script>
